"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationName = exports.appNameAbbreviations = void 0;
const AppContext_1 = require("./AppContext");
const react_1 = require("react");
exports.appNameAbbreviations = {
    admin: "A",
    portal: "P",
    servicepro: "W",
    storybook: "K"
};
function useApplicationName() {
    const location = window.location;
    const { hostname, port } = react_1.useMemo(() => location, [location]);
    const { app: contextValue } = react_1.useContext(AppContext_1.AppContext);
    if (contextValue) {
        const appNameAbbreviation = contextValue;
        const appName = Object.keys(exports.appNameAbbreviations).find(k => exports.appNameAbbreviations[k] === contextValue);
        if (appName && appNameAbbreviation) {
            return { appName: appName, appNameAbbreviation };
        }
    }
    if (port === "6006") {
        return {
            appName: "storybook",
            appNameAbbreviation: exports.appNameAbbreviations["storybook"]
        };
    }
    else if (hostname.contains("admin") || port === "1883") {
        return {
            appName: "admin",
            appNameAbbreviation: exports.appNameAbbreviations["admin"]
        };
    }
    else if (hostname.contains("portal") || port === "1884") {
        return {
            appName: "portal",
            appNameAbbreviation: exports.appNameAbbreviations["portal"]
        };
    }
    else {
        return {
            appName: "servicepro",
            appNameAbbreviation: exports.appNameAbbreviations["servicepro"]
        };
    }
}
exports.useApplicationName = useApplicationName;
//# sourceMappingURL=useApplicationName.js.map